import { Plugin } from '@nuxt/types'
import type { ContentfulClientApi, CreateClientParams } from 'contentful'

require('dotenv').config()
const contentful = require('contentful') as typeof import('contentful')

// use default environment config for convenience
// these will be set via `env` property in nuxt.config.js

// NOTE (latent bug, behaviour preserved): `logHandler` is declared by Contentful
// as `(level, data?) => void`, but the original config passes an empty object `{}`.
// We keep that exact runtime value and cast to satisfy the type.
const config = {
  space: process.env.CTF_SPACE_ID,
  accessToken: process.env.CTF_CDA_ACCESS_TOKEN,
  environment: process.env.CTF_ENVIRONMENT,
  host: process.env.CTF_HOST,
  retryOnError: false,
  retryLimit: 1,
  logHandler: {
  }
} as CreateClientParams

const contentfulPlugin: Plugin = (context, inject) => {
  // Inject $content in Vue, context and store.
  inject('contentful', contentful.createClient(config))
}

export default contentfulPlugin

// export `createClient` to use it outside of nuxt
export const createClient = function (): ContentfulClientApi {
  return contentful.createClient(config)
}
